import { Backdrop, Box, Checkbox, CircularProgress, Dialog, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton, MenuItem, Select, SelectChangeEvent, Skeleton, Stack, TableCell, TableRow, Theme, Tooltip, Typography, useTheme } from '@mui/material';
import { Form, Formik, FormikProps } from '../../../lib/formik/Formik';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { ReportSectionContainer, ReportsRightLayout } from '../../InvestorReport/index';
import { getDashboardReports, getInvestorReports } from '../../../redux-store/actions/investorReports';
import {
    downloadMultipleFiles,
    formatDate,
    maskInfo,
    replaceLetterOWithW,
} from '../../../utils/utilityFunctions';
import { TextDatePicker } from '../../onboarding/DatePickerWithTextFeild';
import { MFSubmitButton, MFTextField } from '../../../lib/formik';
import { validationSchemaPortfolioSummary } from '../../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import FormMultiSelect from '../../../lib/formik/FormMultiSelect';
import { getRMDashBoardMetrics } from '../../../redux-store/actions/userManagement';
import { useEffect, useRef, useState } from 'react';
import { ReportsListObj, ReportsListRes, ReportsPortfolioObj, RmDashboardType } from '../../../redux-store/types/api-types';
import { useFormik } from '../../../lib/formik/Formik';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "../../../utils/dayjs";
import MFSelectField from '../../../lib/formik/SelectField';
import { RootStateType } from '../../../redux-store/reducers';
import { clientStatementDownload, createClientStatement, getClientStatementList, getClientStatementPDF, getFamilyMembers, getReportsAnalystInvestorList, getReportsInvestorList, renewedClientStatementPDF, updateClientStatementStatus } from '../../../redux-store/actions/reports';
import * as Yup from 'yup';
import { DayJsDatePicker } from '../../onboarding/newDatePicker';
import { reportDownload } from '../../Reports/report-utils';
import { DialogCloseIcon, InfoIconOutlined, RefreshIcon, YellowWarning } from '../../../assets/SvgIcons';
import { CONTENT_TYPE, MPOWER_ACCOUNT_TYPE_MASTER, REPORTS_FILTER_TYPE_OPTIONS, requestReportsMaster, USER_ROLES } from '../../../utils/constant';
import FormikSearchDropdown from '../../../lib/formik/FormikSearchDropdown';
import CustomTable from '../../investorOverview/common/customTable';
import { Order, PaginationObj, SortingObj, TableHeaderData } from '../../investorOverview/types';
import { DownloadIcon } from '../../customSVGs';
import ClientStatementTable from '../../ClientStatementTable';
import { ClientStatementReportsList, CreateClientStatementResponseBody, FamilyMemberObj, GetClientStatementListResponseBody, GetFamilyMembersResponseBody, UpdateClientStatementStatusResponseBody } from '../../../redux-store/types/onBoarding';
import MFCheckbox from '../../../lib/formik/Checkbox';

interface Values {
    // selectedFamily: number;
    selectedInvestor: ReportsListObj | null;
    filterType: string;
    isHeldAway: boolean;
    filterTypeOptions: Array<{ key: string; value: string; }>;
    familyName: string;
    // selectedPortfolio: ReportsPortfolioObj | null;
    // startDate: any;
    endDate: any;
    reportSections: Array<string>;
    isExcFep: boolean;
    isHeldAwayCalc: boolean;
    familyMembersArray: Array<FamilyMemberObj>;
    selectedFamilyMember: FamilyMemberObj | null;
}

const INTERVAL_DURATION = 60 * 1000

export function ClientStatement({
    handleSideSectionDisabled
}: {
    handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState<boolean>(false);
    const { iwappRmId } = useSelector((state: RootStateType) => state.id);
    const { role = '' } = useSelector((state: RootStateType) => state.auth);

    const [investorListData, setInvestorListData] = useState<ReportsListRes>({} as ReportsListRes);
    const [isInitiating, setIsInitiating] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)
    const [isTableDataLoading, setTableDataLoading] = useState<boolean>(false)
    const [tableData, setTableData] = useState<Array<ClientStatementReportsList>>([])
    const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: "createdAt"
    })
    const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0
    })
    const [selectedJobIdForDownload, setSelectedJobIdForDownload] = useState<string | null>(null)
    const [isFamilyMembersDataLoading, setFamilyMembersDataLoading] = useState<boolean>(false)

    const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);

    const formikRef = useRef<FormikProps<Values>>(null);

    const tablePaginationObjRef = useRef(tablePaginationObj)
    const tableSortingObjRef = useRef(tableSortingObj)
    const tableDataRef = useRef(tableData)

    const fetchInvestorList = async () => {
        try {
            setLoading(true);

            let response = {} as ReportsListRes

            if ([USER_ROLES.ANALYST].includes(role)) {
                response = await (dispatch(getReportsAnalystInvestorList({
                    analystId: `${iwappRmId}`
                })) as unknown as Promise<ReportsListRes>);
            } else {
                response = await (dispatch(getReportsInvestorList({
                    rmId: `${iwappRmId}`,
                    reportName: "client-statement"
                })) as unknown as Promise<ReportsListRes>);
            }

            setInvestorListData(response);
            if (!response?.isSuccess) {
                setNoInvestorDialogVisible(true)
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setLoading(false);
        }
    };

    const fetchTableData = async ({
        currentPage,
        rowsPerPage,
        sort,
        order,
        updatePendingReports
    }: {
        currentPage: number;
        rowsPerPage: number;
        sort: string;
        order: Order;
        updatePendingReports: boolean
    }) => {
        try {
            setTableDataLoading(true)

            const payload = {
                rmId: `${iwappRmId}`,
                sort,
                order,
                currentPage,
                rowsPerPage,
                updatePendingReports
            }

            const {
                count = 0,
                reports = []
            } = await (dispatch(updateClientStatementStatus(payload)) as unknown as Promise<UpdateClientStatementStatusResponseBody>)

            setTableData(reports)
            setTableSortingObj({
                order,
                orderBy: sort
            })
            setTablePaginationObj({
                currentPage: currentPage - 1,
                rowsPerPage,
                totalRows: count
            })
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setTableDataLoading(false)
        }
    }

    useEffect(() => {
        tablePaginationObjRef.current = tablePaginationObj;
        tableSortingObjRef.current = tableSortingObj;
        tableDataRef.current = tableData
    }, [tablePaginationObj, tableSortingObj, tableData]);


    useEffect(() => {
        if (!iwappRmId) return

        const fetchData = async () => {
            await Promise.allSettled([
                fetchInvestorList(),
                fetchTableData({
                    currentPage: tablePaginationObj.currentPage + 1,
                    rowsPerPage: tablePaginationObj.rowsPerPage,
                    sort: tableSortingObj.orderBy,
                    order: tableSortingObj.order,
                    updatePendingReports: true
                })
            ])
        }

        fetchData()

        const intervalId = setInterval(async () => {
            if ((tableDataRef.current ?? []).some(obj => `${obj?.status ?? ""}`.toLowerCase() === "pending")) {
                await fetchTableData({
                    currentPage: tablePaginationObjRef.current.currentPage + 1,
                    rowsPerPage: tablePaginationObjRef.current.rowsPerPage,
                    sort: tableSortingObjRef.current.orderBy,
                    order: tableSortingObjRef.current.order,
                    updatePendingReports: true,
                });
            }
        }, INTERVAL_DURATION);

        return () => clearInterval(intervalId);

    }, [iwappRmId])

    const todayDate = new Date();
    const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").subtract(1, "day").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");
    // const formattedBusinessDate = '2025-05-02';
    // const formattedBusinessDate = dayjs(todayDate).subtract(1, "day").format("YYYY-MM-DD");

    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);
    const formattedFirstDayOfYear = dayjs(firstDayOfYear).format('YYYY-MM-DD');

    const initialValues: Values = {
        // selectedFamily: 0,
        selectedInvestor: null,
        filterType: "PORTFOLIO",
        isHeldAway: false,
        filterTypeOptions: REPORTS_FILTER_TYPE_OPTIONS,
        familyName: "",
        // selectedPortfolio: null,
        // startDate: formattedFirstDayOfYear,
        endDate: formattedBusinessDate,
        reportSections: [],
        isExcFep: false,
        isHeldAwayCalc: false,
        familyMembersArray: [],
        selectedFamilyMember: null
    };


    const mfTransactionValidations = Yup.object().shape({
        selectedInvestor: Yup
            .object()
            .nullable()
            .test(
                "investor-required",
                "Please select an investor",
                function (value) { return !!value }
            ),
        filterType: Yup
            .string()
            .required('Please select a Filter type'),
        // selectedPortfolio: Yup
        //     .object()
        //     .nullable()
        //     .test(
        //         "portfolio-required",
        //         "Please select a portfolio",
        //         function (value) { return !!value }
        //     ),
        // selectedFamily: Yup.string().required('Required'),
        // startDate: Yup.
        //     date()
        //     .typeError('Start Date should be valid date')
        //     .min(dayjs(formattedFirstDayOfYear).format("YYYY-MM-DD"), `Start Date should not be less than ${dayjs(formattedFirstDayOfYear).format("DD/MM/YYYY")}`)
        //     .test('fromDateTest', 'Start Date cannot be greater than As on Date', function (value) {
        //         const { endDate } = this.parent;
        //         return !endDate || !value || value <= endDate;
        //     }),
        endDate: Yup
            .date()
            .required('As on Date is required')
            .typeError('As on Date is required')
            .max(formattedBusinessDate, "As on Date should not be greater than system's date"),
        // .test('toDateTest', 'As on Date cannot be less than Start Date ', function (value) {
        //     const { startDate } = this.parent;
        //     return !startDate || !value || value >= startDate;
        // }),
        reportSections: Yup
            .array()
            .of(Yup.string())
            .min(1, 'Please select a report section')
    })

    const familyDropdownOptions = [
        {
            key: 'By Family',
            value: 1
        },
        {
            key: 'By Individual',
            value: 0
        }
    ]

    const handleRefresh = async () => {
        await fetchTableData({
            currentPage: 1,
            rowsPerPage: tablePaginationObj.rowsPerPage,
            sort: tableSortingObj.orderBy,
            order: tableSortingObj.order,
            updatePendingReports: true
        })
    }

    const handleSubmit = async ({
        // selectedFamily,
        selectedInvestor,
        // selectedPortfolio,
        filterType,
        isHeldAway,
        // startDate,
        endDate,
        reportSections,
        isExcFep,
        isHeldAwayCalc,
        selectedFamilyMember
    }: Values) => {
        try {
            setIsInitiating(true)
            handleSideSectionDisabled(true)

            // const payload = {
            //     rmID: `${iwappRmId}`,
            //     family: Boolean(selectedFamily),
            //     // clientCode: investor?.clientCode || '',
            //     customer_name: selectedInvestor?.clientCode ?? '',
            //     portfolio: selectedPortfolio?.portfolioId ?? "",
            //     // from: dayjs(date, "YYYY-MM-DD").subtract(1, "year").format("DD/MM/YYYY"),
            //     // end: dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
            //     report_date: dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD"),
            //     requested_reports: (reportSections ?? []).map(Number)
            // }

            // const renewedPayload = {
            //     clientCode: selectedInvestor?.clientCode ?? '',
            // }

            const idMap: { [key: string]: string } = {
                FAMILY: selectedInvestor?.familyId ?? "",
                CUSTOMER: selectedFamilyMember ? (selectedFamilyMember?.panNo ?? "") : (selectedInvestor?.panNo ?? ""),
                PORTFOLIO: selectedFamilyMember ? (selectedFamilyMember?.portfolioList?.[0]?.portfolioId ?? "") : (selectedInvestor?.portfolioList?.[0]?.portfolioId ?? "")
            }

            const payload = {
                clientCode: selectedFamilyMember ? `${selectedFamilyMember?.clientCode ?? ""}` : `${selectedInvestor?.clientCode ?? ""}`,
                rmId: `${iwappRmId}`,
                // startDate: `${startDate ?? ""}`,
                endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
                accountType: selectedFamilyMember ? (selectedFamilyMember?.accountType ?? "") : (selectedInvestor?.accountType ?? ""),
                requested_reports: (reportSections ?? []).map(Number),
                consolidatedLevel: filterType === "CUSTOMER" ? "PAN" : filterType,
                custFilterValue: idMap[filterType ?? ""] ?? "",
                heldAway: isHeldAway ? 'Y' : 'N',
                isExcFep: isExcFep ? 'Y' : 'N',
                isHeldAwayCalc: isHeldAwayCalc ? 'Y' : 'N',
            }
            // const response = await (dispatch(getClientStatementPDF(payload)) as unknown as Promise<any>)
            // const response = await (dispatch(renewedClientStatementPDF(renewedPayload)) as unknown as Promise<any>)

            const response = await (dispatch(createClientStatement(payload)) as unknown as Promise<CreateClientStatementResponseBody>)

            // if (response.type === CONTENT_TYPE.PDF) {
            //     enqueueSnackbar('File downloaded successfully.', {
            //         variant: 'success',
            //         autoHideDuration: 2000,
            //     });
            //     reportDownload(response as unknown as Blob, `${selectedInvestor?.customerName || ''}-ClientStatement.pdf`);
            // } else {
            //     enqueueSnackbar('File download failed!.', {
            //         variant: 'error',
            //         autoHideDuration: 2000,
            //     });
            // }

            if (response?.isSuccess) {
                enqueueSnackbar(`${response?.message ?? ""}`, {
                    variant: 'success',
                    autoHideDuration: 5000,
                });

                await handleRefresh()

                return
            }
            if (!response?.isSuccess) {
                enqueueSnackbar(`${response?.message ?? ""}`, {
                    variant: 'error',
                    autoHideDuration: 5000,
                });

                return
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setIsInitiating(false)
            handleSideSectionDisabled(false)
        }
    }

    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }

    const handleInvestorChange = async (selectedObj: Record<string, any>) => {
        try {
            if (!formikRef.current) return

            const { values, setValues } = formikRef.current ?? {}

            if (!selectedObj) {
                setValues({
                    ...values,
                    selectedInvestor: null,
                    // selectedPortfolio: null,
                    filterType: "PORTFOLIO",
                    isHeldAway: false,
                    filterTypeOptions: REPORTS_FILTER_TYPE_OPTIONS,
                    familyName: "",
                    reportSections: [],
                    isExcFep: false,
                    isHeldAwayCalc: false,
                    familyMembersArray: [],
                    selectedFamilyMember: null
                })

                return
            }

            let familyMembersArrayResponse: Array<FamilyMemberObj> = []

            if (`${selectedObj?.isFamilyHead ?? ""}`.toLowerCase() === "y") {
                setFamilyMembersDataLoading(true)

                const response = await (dispatch(getFamilyMembers(selectedObj?.familyId ?? "")) as unknown as Promise<GetFamilyMembersResponseBody>);

                if (response) {
                    familyMembersArrayResponse = response?.familyMembers ?? []
                }
            }

            setValues({
                ...values,
                selectedInvestor: selectedObj as ReportsListObj,
                // selectedPortfolio: null,
                filterType: "PORTFOLIO",
                isHeldAway: false,
                filterTypeOptions: (`${selectedObj?.isFamilyHead ?? ""}`.toLowerCase() === "y") ? REPORTS_FILTER_TYPE_OPTIONS : REPORTS_FILTER_TYPE_OPTIONS.filter(item => `${item?.key}`.toLowerCase() !== "family"),
                familyName: "",
                reportSections: (values?.reportSections ?? [])
                    .filter(key => key !== "4"),
                isExcFep: false,
                isHeldAwayCalc: false,
                familyMembersArray: familyMembersArrayResponse,
                selectedFamilyMember: null
            })
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setFamilyMembersDataLoading(false)
        }
    }

    const handleFamilyMemberChange = async (selectedObj: Record<string, any>) => {
        try {
            if (!formikRef.current) return

            const { values, setValues } = formikRef.current ?? {}

            if (!selectedObj) {
                setValues({
                    ...values,
                    filterType: "PORTFOLIO",
                    isHeldAway: false,
                    filterTypeOptions: (`${values?.selectedInvestor?.isFamilyHead ?? ""}`.toLowerCase() === "y") ? REPORTS_FILTER_TYPE_OPTIONS : REPORTS_FILTER_TYPE_OPTIONS.filter(item => `${item?.key}`.toLowerCase() !== "family"),
                    familyName: "",
                    reportSections: (values?.reportSections ?? [])
                        .filter(key => key !== "4"),
                    isExcFep: false,
                    isHeldAwayCalc: false,
                    selectedFamilyMember: null
                })

                return
            }

            setValues({
                ...values,
                filterType: "PORTFOLIO",
                isHeldAway: false,
                filterTypeOptions: (`${selectedObj?.isHeadOfFamily ?? ""}`.toLowerCase() === "y") ? REPORTS_FILTER_TYPE_OPTIONS : REPORTS_FILTER_TYPE_OPTIONS.filter(item => `${item?.key}`.toLowerCase() !== "family"),
                familyName: "",
                reportSections: (values?.reportSections ?? [])
                    .filter(key => key !== "4"),
                isExcFep: false,
                isHeldAwayCalc: false,
                selectedFamilyMember: selectedObj as FamilyMemberObj,
            })
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setFamilyMembersDataLoading(false)
        }
    }

    const handleTableSort = async (orderBy: string, order: Order) => {
        await fetchTableData({
            currentPage: 1,
            rowsPerPage: tablePaginationObj.rowsPerPage,
            sort: orderBy,
            order,
            updatePendingReports: false
        })
    }

    const handleTableRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        await fetchTableData({
            currentPage: 1,
            rowsPerPage: Number(event.target.value),
            sort: tableSortingObj.orderBy,
            order: tableSortingObj.order,
            updatePendingReports: false
        })
    }

    const handleTablePageChange = async (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        await fetchTableData({
            currentPage: page + 1,
            rowsPerPage: tablePaginationObj.rowsPerPage,
            sort: tableSortingObj.orderBy,
            order: tableSortingObj.order,
            updatePendingReports: false
        })
    }

    const handleReportDownload = async (jobId: string, clientName: string) => {
        try {
            setIsDownloading(true)
            handleSideSectionDisabled(true)

            setSelectedJobIdForDownload(jobId)

            const payload = { jobId }

            const response = await (dispatch(clientStatementDownload(payload)) as unknown as Promise<any>)

            if (response.type === CONTENT_TYPE.PDF) {
                enqueueSnackbar('File downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 5000,
                });
                reportDownload(response as unknown as Blob, `${clientName ?? ""}-ClientStatement.pdf`);
            } else {
                enqueueSnackbar('File download failed!.', {
                    variant: 'error',
                    autoHideDuration: 5000,
                });
            }

        } catch (e) {
            console.log("Error:", e)
        } finally {
            setIsDownloading(false)
            handleSideSectionDisabled(false)
            setSelectedJobIdForDownload(null)
        }
    }

    const handleFilterTypeChange = ({ target: { value } }: SelectChangeEvent<unknown>) => {
        if (!formikRef?.current) {
            return
        }

        const { values: formikValues, setValues } = formikRef.current

        const modifiedReportSections = [...(formikValues?.reportSections ?? [])]

        if (
            ["customer", "family"].includes(`${value ?? ""}`.toLowerCase()) &&
            !modifiedReportSections.includes("4")
        ) {
            modifiedReportSections.push("4")
        }

        setValues({
            ...formikValues,
            filterType: `${value ?? ""}`,
            isHeldAway: false,
            isHeldAwayCalc: false,
            ...((`${value ?? ""}`.toLowerCase() === "family") ? {
                familyName: formikValues?.selectedFamilyMember ? (formikValues?.selectedFamilyMember?.familyName ?? "") : (formikValues?.selectedInvestor?.familyName ?? "")
            } : {
                familyName: ""
            }),
            reportSections: (modifiedReportSections)
                .filter(key => {
                    if (!["customer", "family"].includes(`${value ?? ""}`.toLowerCase())) {
                        return key !== "4"
                    }
                    return true
                })
        })
    }

    return (
        <>
            <Backdrop
                sx={(theme: Theme) => ({
                    color: theme.palette.common.white,
                    zIndex: theme.zIndex.modal + 1
                })}
                open={isFamilyMembersDataLoading}
            >
                <CircularProgress sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
            </Backdrop>
            <ReportsRightLayout >
                <Typography
                    variant='h2'
                    sx={{
                        color: 'text.primary',
                        lineHeight: '25px',
                        letterSpacing: '0.01px',
                        mb: '40px',
                    }}>
                    Client Statement
                </Typography>

                <Formik
                    innerRef={formikRef}
                    validationSchema={mfTransactionValidations}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ values, setValues }) => {
                        const requestedReportsObj = requestReportsMaster(`${values?.filterType ?? ""}`.toLowerCase())

                        return (
                            <Form>
                                <Grid container rowSpacing={2} >
                                    <Grid item container columnSpacing={3} rowSpacing={2}>
                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <FormikSearchDropdown
                                                    name='selectedInvestor'
                                                    label='Select Investor *'
                                                    options={(investorListData?.result ?? [])?.map((obj: ReportsListObj) => ({
                                                        ...obj,
                                                        label: `${maskInfo(obj.customerName)} (${obj?.clientCode ?? ""}) ${obj?.investorType ? "(" + obj?.investorType + ")" : ""} ${`${obj?.isFamilyHead ?? ""}`.toLowerCase() === "y" ? "(Head Of Family)" : ""} ${MPOWER_ACCOUNT_TYPE_MASTER[obj?.accountType ?? ""] ? " - " + MPOWER_ACCOUNT_TYPE_MASTER[obj.accountType] : ""}`,
                                                        value: obj.clientCode
                                                    }))}
                                                    onChange={handleInvestorChange}
                                                    disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                                                />
                                            )}
                                        </Grid>
                                        {(`${values?.selectedInvestor?.isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                                            <Grid item xs={12} lg={6}>
                                                {(loading || isNavbarInfoLoading) && <Skeleton
                                                    animation={'wave'}
                                                    height={90}

                                                />}
                                                {(!loading && !isNavbarInfoLoading) && (
                                                    <FormikSearchDropdown
                                                        name="selectedFamilyMember"
                                                        label="Family Members"
                                                        options={(values?.familyMembersArray ?? [])?.map((obj: FamilyMemberObj) => ({
                                                            ...obj,
                                                            label: `${maskInfo(obj.name)} (${obj?.clientCode ?? ""}) ${obj?.investorType ? "(" + obj?.investorType + ")" : ""} ${`${obj?.isHeadOfFamily ?? ""}`.toLowerCase() === "y" ? "(Head Of Family)" : ""} ${MPOWER_ACCOUNT_TYPE_MASTER[obj?.accountType ?? ""] ? " - " + MPOWER_ACCOUNT_TYPE_MASTER[obj.accountType] : ""}`,
                                                            value: obj.clientCode
                                                        }))}
                                                        onChange={handleFamilyMemberChange}
                                                        disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                                                    />
                                                )}
                                            </Grid>
                                        )}
                                        {/* Filter Type Dropdown start */}
                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <MFSelectField
                                                    name='filterType'
                                                    label="Filter Type *"
                                                    items={values?.filterTypeOptions ?? []}
                                                    disabled={
                                                        loading ||
                                                        isDownloading ||
                                                        isNavbarInfoLoading ||
                                                        isInitiating ||
                                                        !values?.selectedInvestor
                                                    }
                                                    onChange={handleFilterTypeChange}
                                                />
                                            )}
                                        </Grid>
                                        {/* Filter Type Dropdown end */}

                                        {/* Family Name start */}
                                        {(`${values?.filterType ?? ""}`.toLowerCase() === "family") && (
                                            <Grid item xs={12} lg={6}>
                                                <MFTextField
                                                    name="familyName"
                                                    label="Family Name"
                                                    placeholder=""
                                                    disabled={true}
                                                    value={values?.familyName ?? ""}
                                                />
                                            </Grid>
                                        )}
                                        {/* Family Name end */}

                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <>
                                                    <TextDatePicker
                                                        name="endDate"
                                                        label="As on date *"
                                                        placeholder=""
                                                        maxDate={new Date(formattedBusinessDate)}
                                                        disabled={
                                                            loading ||
                                                            isDownloading ||
                                                            isNavbarInfoLoading ||
                                                            isInitiating
                                                        }
                                                    />
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            columnGap: "10px",
                                                            marginTop: "-10px"
                                                        }}>
                                                        <InfoIconOutlined />
                                                        <Typography
                                                            variant='subtitle_600'
                                                            sx={(theme: Theme) => ({
                                                                color: theme.palette.grey[900]
                                                            })}
                                                        >
                                                            Reports are generated Since Inception.
                                                        </Typography>
                                                    </Box>
                                                </>
                                            )}
                                        </Grid>
                                        {/* <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}
    
                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <FormikSearchDropdown
                                                    name='selectedPortfolio'
                                                    label='Select Portfolio *'
                                                    options={(values?.selectedInvestor?.portfolioList ?? [])?.map(obj => ({
                                                        ...obj,
                                                        label: `${obj?.portfolioName ?? ""} (${obj?.portfolioId ?? ""})`,
                                                        value: obj?.portfolioId ?? ""
                                                    }))}
                                                    disabled={
                                                        loading ||
                                                        isDownloading ||
                                                        isNavbarInfoLoading ||
                                                        !values?.selectedInvestor
                                                    }
                                                />
                                            )}
                                        </Grid> */}
                                        {/* <Grid item xs={12} lg={6}>
                                                {(loading || isNavbarInfoLoading) && <Skeleton
                                                    animation={'wave'}
                                                    height={90}
    
                                                />}
                                                {(!loading && !isNavbarInfoLoading) && <MFSelectField
                                                    name={'selectedFamily'}
                                                    label="Family"
                                                    placeholder='Select Family'
                                                    items={familyDropdownOptions}
                                                    value={values.selectedFamily}
                                                    onChange={(e) => {
                                                        setFieldValue("selectedFamily", e.target.value);
                                                    }}
                                                    sx={(theme: Theme) => ({
                                                        '& .Mui-disabled': {
                                                            cursor: !(loading || isDownloading) ? 'pointer' : 'not-allowed !important',
                                                            pointerEvents: 'all',
                                                        },
                                                        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: `${theme.palette.text.secondary}4D`,
                                                        },
                                                        '&.Mui-disabled .MuiSelect-select': {
                                                            color: "green",
                                                        },
                                                        '&.Mui-disabled svg': {
                                                            color: `${theme.palette.text.secondary}4D`,
                                                        },
                                                    })}
                                                    disabled={loading || isDownloading || isNavbarInfoLoading}
                                                />}
                                            </Grid> */}
                                        {/* <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}
    
                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <DayJsDatePicker
                                                    id=""
                                                    name='startDate'
                                                    label="Start date"
                                                    maxDate={new Date(formattedBusinessDate)}
                                                    disabled={
                                                        loading ||
                                                        isDownloading ||
                                                        isNavbarInfoLoading ||
                                                        isInitiating
                                                    }
                                                    currentDate={formattedFirstDayOfYear}
                                                />
                                            )}
                                        </Grid> */}
                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <FormMultiSelect
                                                    name="reportSections"
                                                    label='Select Report Sections *'
                                                    options={Object.keys(requestedReportsObj)
                                                        .filter(key => {
                                                            if (!["customer", "family"].includes(`${values?.filterType ?? ""}`.toLowerCase())) {
                                                                return key !== "4"
                                                            }
                                                            return true
                                                        })
                                                        .map(key => ({
                                                            label: requestedReportsObj[key],
                                                            value: key
                                                        }))}
                                                    sx={{
                                                        "&.MuiOutlinedInput-root": {
                                                            "& fieldset>legend": {
                                                                fontSize: { xs: "0.6em", md: "0.7em", lg: "0.8em" }
                                                            }
                                                        }
                                                    }}
                                                    disabled={
                                                        loading ||
                                                        isDownloading ||
                                                        isNavbarInfoLoading ||
                                                        isInitiating
                                                    }
                                                />
                                            )}
                                        </Grid>

                                        {/* Exclude Fully Exited Positions Checkbox start */}
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            lg={6}
                                            sx={{ alignItems: "center" }}
                                        >
                                            <Grid item>
                                                <MFCheckbox
                                                    name="isExcFep"
                                                    label="Exclude Fully Exited Positions"
                                                    sx={(theme: Theme) => ({
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        color: `${theme.palette.text.primary}`,
                                                        "& :disabled": {
                                                            color: `${theme.palette.text.secondary}`,
                                                        }
                                                    })}
                                                    disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                                                />
                                            </Grid>
                                        </Grid>
                                        {/* Exclude Fully Exited Positions Checkbox end */}

                                        {/* HeldAway Checkbox start */}
                                        {(`${values?.filterType ?? ""}`.toLowerCase() !== "portfolio") && (
                                            <Grid
                                                item
                                                container
                                                xs={12}
                                                lg={6}
                                                sx={{ alignItems: "center" }}
                                            >
                                                <Grid item>
                                                    <MFCheckbox
                                                        name="isHeldAway"
                                                        label="Include Held Away in Overview page"
                                                        sx={(theme: Theme) => ({
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            color: `${theme.palette.text.primary}`,
                                                            "& :disabled": {
                                                                color: `${theme.palette.text.secondary}`,
                                                            }
                                                        })}
                                                        disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                                                        onChange={({ target: { checked } }) => {
                                                            setValues({
                                                                ...values,
                                                                isHeldAway: checked,
                                                                isHeldAwayCalc: !checked ? false : values?.isHeldAwayCalc
                                                            })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                        {/* HeldAway Checkbox end */}

                                        {/* Include Heldaway in calculations Checkbox start */}
                                        {(`${values?.filterType ?? ""}`.toLowerCase() !== "portfolio") && (
                                            <Grid
                                                item
                                                container
                                                xs={12}
                                                lg={6}
                                                sx={{ alignItems: "center" }}
                                            >
                                                <Grid item>
                                                    <MFCheckbox
                                                        name="isHeldAwayCalc"
                                                        label="Include Held Away in calculations"
                                                        sx={(theme: Theme) => ({
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            color: `${theme.palette.text.primary}`,
                                                            "& :disabled": {
                                                                color: `${theme.palette.text.secondary}`,
                                                            }
                                                        })}
                                                        disabled={
                                                            loading ||
                                                            isDownloading ||
                                                            isNavbarInfoLoading ||
                                                            isInitiating ||
                                                            !values?.isHeldAway
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                        {/* Include Heldaway in calculations Checkbox end */}

                                    </Grid>
                                    <Grid item container columnSpacing={3} justifyContent={"flex-end"}>
                                        <Grid item xs={8} />
                                        <Grid item xs={4}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <MFSubmitButton
                                                    label="Initiate"
                                                    loadingEnable={isInitiating}
                                                    disabled={loading || isDownloading}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid >
                            </Form >
                        )
                    }}
                </Formik >
                <Divider sx={{ mt: 4, mb: 4 }} />
                <Box sx={{ marginTop: 1 }}>
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: "10px"
                            }}
                        >
                            <Box>
                                <Typography
                                    variant='h2'
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        ...theme.typography.body_600,
                                    })}
                                >
                                    Existing Client Statements
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "5px",
                                        marginLeft: '-2px',
                                        mt: 0.5
                                    }}>
                                    <InfoIconOutlined />
                                    <Typography
                                        variant='subtitle_600'
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.grey[900]
                                        })}
                                    >
                                        Statements will be available for 1 day only.
                                    </Typography>
                                </Box>
                            </Box>
                            <IconButton
                                sx={{
                                    cursor: 'pointer',
                                    "&: disabled": {
                                        opacity: 0.5
                                    }
                                }}
                                onClick={handleRefresh}
                                disabled={isTableDataLoading}
                                aria-label="Refresh Client Statement Report"
                            >
                                <RefreshIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ marginTop: 5 }}>
                            <ClientStatementTable
                                isLoading={isTableDataLoading}
                                tableData={tableData}
                                handleTableSort={handleTableSort}
                                tablePaginationObj={tablePaginationObj}
                                handleTableRowsPerPageChange={handleTableRowsPerPageChange}
                                handleTablePageChange={handleTablePageChange}
                                tableSortingObj={tableSortingObj}
                                handleReportDownload={handleReportDownload}
                                isDownloading={isDownloading}
                                selectedJobIdForDownload={selectedJobIdForDownload}
                            />
                        </Box>
                    </Box>
                </Box>
            </ReportsRightLayout >
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
        </>
    );
};
